import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import Products from "../pages/products/page";
import Spreadsheet from "../pages/spreadsheet/page";
import Review from "../pages/review/page";
import Shipping from "../pages/shipping/page";
import Coupon from "../pages/coupon/page";
import Warehouse from "../pages/warehouse/page";
import Legit from "../pages/legit/page";
import Safety from "../pages/safety/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Disclaimer from "../pages/disclaimer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products/",
    element: <Products />,
  },
  {
    path: "/cssbuy-spreadsheet/",
    element: <Spreadsheet />,
  },
  {
    path: "/cssbuy-review/",
    element: <Review />,
  },
  {
    path: "/cssbuy-shipping-cost/",
    element: <Shipping />,
  },
  {
    path: "/cssbuy-coupon/",
    element: <Coupon />,
  },
  {
    path: "/cssbuy-warehouse/",
    element: <Warehouse />,
  },
  {
    path: "/cssbuy-legit/",
    element: <Legit />,
  },
  {
    path: "/safety/",
    element: <Safety />,
  },
  {
    path: "/faq/",
    element: <Faq />,
  },
  {
    path: "/about/",
    element: <About />,
  },
  {
    path: "/contact/",
    element: <Contact />,
  },
  {
    path: "/privacy-policy/",
    element: <Privacy />,
  },
  {
    path: "/terms/",
    element: <Terms />,
  },
  {
    path: "/disclaimer/",
    element: <Disclaimer />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;